<template>

  <div class="user">
    <!--筛选-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="会议名称">
          <el-input placeholder="请输入会议名称" v-model="formInline.name" style="width: 180px;"></el-input>
        </el-form-item>
        <el-form-item label="所属组织">
          <el-select v-model="formInline.affiliated_organization" placeholder="请选择所属组织" clearable style="width: 180px;">
            <el-option label="所有" value=""></el-option>
            <el-option v-for="item in organizationList" :key="item.ma_organization_id" :label="item.name" :value="item.ma_organization_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="会议分类">
          <el-select v-model="formInline.meeting_category" placeholder="请选择会议分类" clearable style="width: 180px;">
            <el-option label="所有" value=""></el-option>
            <el-option v-for="item in conferenceClassificationList" :key="item.ma_conference_classification_id" :label="item.name" :value="item.ma_conference_classification_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="会议时间">
          <el-date-picker
            v-model="formInline.meeting_time_range"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            style="width: 280px;">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
          <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="45"></el-table-column>

            <el-table-column prop="name" label="会议名称" width="200"></el-table-column>
            <el-table-column prop="affiliated_organization" label="所属组织" width="120"></el-table-column>
            <el-table-column prop="meeting_category" label="会议分类" width="120"></el-table-column>
            <el-table-column prop="meeting_introduction" label="会议简介" width="200" show-overflow-tooltip></el-table-column>
            <el-table-column prop="meeting_host" label="会议主持人" width="100"></el-table-column>
            <el-table-column prop="meeting_recorder" label="会议记录人" width="100"></el-table-column>
            <el-table-column prop="meeting_time" label="会议时间" width="160"></el-table-column>
            <el-table-column prop="meeting_place" label="会议地点" width="150"></el-table-column>
            <el-table-column label="会议状态" width="100">
              <template slot-scope="scope">
                <el-tag v-if="getMeetingStatus(scope.row.meeting_time) === '未开始'" type="info">未开始</el-tag>
                <el-tag v-else-if="getMeetingStatus(scope.row.meeting_time) === '进行中'" type="warning">进行中</el-tag>
                <el-tag v-else-if="getMeetingStatus(scope.row.meeting_time) === '已结束'" type="success">已结束</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="progress" label="会议进度" width="120">
              <template slot-scope="scope">
                <el-progress :percentage="scope.row.progress || 0" :status="getProgressStatus(scope.row.progress)"></el-progress>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="200">
              <template slot-scope="scope">
                <!-- <el-button @click="viewDetail(scope.row)" type="text" size="small">查看详情</el-button> -->
                <!-- <el-button @click="editProgress(scope.row)" type="text" size="small">更新进度</el-button> -->
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background
            :current-page="curPage"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <!--会议详情弹窗-->
    <el-dialog title="会议详情" :visible.sync="detailDialogVisible" width="70%" @close="closeDetailDialog">
      <div class="meeting-detail">
        <el-descriptions :column="2" border>
          <el-descriptions-item label="会议名称">{{ currentMeeting.name }}</el-descriptions-item>
          <el-descriptions-item label="所属组织">{{ currentMeeting.affiliated_organization }}</el-descriptions-item>
          <el-descriptions-item label="会议分类">{{ currentMeeting.meeting_category }}</el-descriptions-item>
          <el-descriptions-item label="会议简介">{{ currentMeeting.meeting_introduction }}</el-descriptions-item>
          <el-descriptions-item label="会议主持人">{{ currentMeeting.meeting_host }}</el-descriptions-item>
          <el-descriptions-item label="会议记录人">{{ currentMeeting.meeting_recorder }}</el-descriptions-item>
          <el-descriptions-item label="会议时间">{{ currentMeeting.meeting_time }}</el-descriptions-item>
          <el-descriptions-item label="会议地点">{{ currentMeeting.meeting_place }}</el-descriptions-item>
          <el-descriptions-item label="会议模式">{{ currentMeeting.meeting_mode }}</el-descriptions-item>
          <el-descriptions-item label="会议周期">{{ currentMeeting.meeting_cycle }}</el-descriptions-item>
          <el-descriptions-item label="发布组织">{{ currentMeeting.publish_organization }}</el-descriptions-item>
          <el-descriptions-item label="会议标签">{{ currentMeeting.meeting_tags }}</el-descriptions-item>
          <el-descriptions-item label="参会人员">{{ currentMeeting.participants }}</el-descriptions-item>
        </el-descriptions>
        
        <div class="meeting-progress-section">
          <h4>会议进度</h4>
          <el-timeline>
            <el-timeline-item
              v-for="(item, index) in progressList"
              :key="index"
              :timestamp="item.create_time"
              :type="getTimelineType(item.status)">
              {{ item.content }}
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
    </el-dialog>

    <!--更新进度弹窗-->
    <el-dialog title="更新会议进度" :visible.sync="progressDialogVisible" width="50%" @close="closeProgressDialog">
      <el-form :model="progressForm" label-width="100px" size="small">
        <el-form-item label="会议名称">
          <el-input v-model="progressForm.meeting_name" disabled></el-input>
        </el-form-item>
        <el-form-item label="当前进度" prop="progress">
          <el-slider v-model="progressForm.progress" :marks="{ 0: '0%', 25: '25%', 50: '50%', 75: '75%', 100: '100%' }"></el-slider>
        </el-form-item>
        <el-form-item label="进度说明" prop="content">
          <el-input type="textarea" v-model="progressForm.content" :rows="4" placeholder="请输入进度说明"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeProgressDialog">取消</el-button>
        <el-button type="primary" @click="submitProgress">确定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import Ma_new_meetingApi from '@/api/ma_new_meeting.js';
import Ma_organizationApi from '@/api/ma_organization.js';
import Ma_conference_classificationApi from '@/api/ma_conference_classification.js';

export default {
  data() {
    return {
      loading: true,
      tableData: [],
      pageSize: 20,
      totalDataNumber: 0,
      curPage: 1,
      form: {},
      formInline: {
        name: "",
        affiliated_organization: "",
        meeting_category: "",
        meeting_time_range: []
      },
      organizationList: [],
      conferenceClassificationList: [],
      selection: [],
      selectedRows: [],
      detailDialogVisible: false,
      progressDialogVisible: false,
      currentMeeting: {},
      progressList: [],
      progressForm: {
        meeting_id: "",
        meeting_name: "",
        progress: 0,
        content: ""
      }
    };
  },
  created() {
    this.loadOrganizations();
    this.loadConferenceClassifications();
    this.getTableList();
  },
  methods: {
    loadOrganizations() {
      let self = this;
      Ma_organizationApi.list({}, true)
          .then(data => {
            if (data.code == 1) {
              self.organizationList = data.data.list.data;
            }
          })
          .catch(error => {
          });
    },

    loadConferenceClassifications() {
      let self = this;
      Ma_conference_classificationApi.list({}, true)
          .then(data => {
            if (data.code == 1) {
              self.conferenceClassificationList = data.data.list.data;
            }
          })
          .catch(error => {
          });
    },

    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },

    resetSearch() {
      this.formInline = {
        name: "",
        affiliated_organization: "",
        meeting_category: "",
        meeting_time_range: []
      };
      this.curPage = 1;
      this.getTableList();
    },

    getData() {
      this.getTableList();
    },

    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;

      if (Params.meeting_time_range && Params.meeting_time_range.length === 2) {
        Params.meeting_time_start = Params.meeting_time_range[0];
        Params.meeting_time_end = Params.meeting_time_range[1];
      }
      delete Params.meeting_time_range;

      self.loading = true;
      Ma_new_meetingApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
    },

    getMeetingStatus(meetingTime) {
      if (!meetingTime) return '未开始';
      const now = new Date();
      const meetingDate = new Date(meetingTime);
      const diffTime = now - meetingDate;
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
      
      if (diffDays < 0) {
        return '未开始';
      } else if (diffDays === 0) {
        return '进行中';
      } else {
        return '已结束';
      }
    },

    getProgressStatus(progress) {
      if (progress >= 100) return 'success';
      if (progress >= 75) return 'warning';
      if (progress >= 50) return 'exception';
      return '';
    },

    getTimelineType(status) {
      const statusMap = {
        'pending': 'primary',
        'processing': 'warning',
        'completed': 'success'
      };
      return statusMap[status] || 'primary';
    },

    viewDetail(row) {
      this.currentMeeting = row;
      this.loadMeetingProgress(row.ma_new_meeting_id);
      this.detailDialogVisible = true;
    },

    loadMeetingProgress(meetingId) {
      let self = this;
      Ma_new_meetingApi.detail({ ma_new_meeting_id: meetingId }, true)
          .then(data => {
            if (data.code == 1) {
              self.progressList = data.data.progress_list || [];
            }
          })
          .catch(error => {
          });
    },

    editProgress(row) {
      this.progressForm = {
        meeting_id: row.ma_new_meeting_id,
        meeting_name: row.name,
        progress: row.progress || 0,
        content: ""
      };
      this.progressDialogVisible = true;
    },

    submitProgress() {
      let self = this;
      if (!self.progressForm.content) {
        self.$message.warning('请输入进度说明');
        return;
      }
      
      Ma_new_meetingApi.updateProgress(self.progressForm, true)
          .then(data => {
            if (data.code == 1) {
              self.$message.success('进度更新成功');
              self.progressDialogVisible = false;
              self.getTableList();
            } else {
              self.$message.error(data.msg || '更新失败');
            }
          })
          .catch(error => {
          });
    },

    closeDetailDialog() {
      this.detailDialogVisible = false;
    },

    closeProgressDialog() {
      this.progressDialogVisible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.user {
  padding: 20px;
}

.common-seach-wrap {
  margin-bottom: 20px;
}

.product-content {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
}

.table-wrap {
  margin-top: 20px;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}

.meeting-detail {
  padding: 20px;
}

.meeting-progress-section {
  margin-top: 30px;
  
  h4 {
    margin-bottom: 20px;
    font-size: 16px;
    color: #333;
  }
}

.dialog-footer {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/ma_new_meeting/index/meeting_progress.vue